// extracted by mini-css-extract-plugin
export var container = "styles-module--container--1f273";
export var desktop = "1340px";
export var errorMessage = "styles-module--errorMessage--9fa40";
export var giant = "2200px";
export var headerText = "styles-module--headerText--3fb02";
export var inlineFields = "styles-module--inlineFields--6b3a2";
export var input = "styles-module--input--17d46";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";
export var title = "styles-module--title--6d603";